var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            {
              staticClass: "flex-wrap",
              class: _vm.$auth.watch.authenticated
                ? "authenticated"
                : "unauthenticated"
            },
            [
              !_vm.$auth.watch.authenticated
                ? _c(
                    "v-toolbar",
                    { attrs: { app: "", color: "secondary" } },
                    [
                      _c("h3", { staticClass: "applogo nulogo" }, [
                        _vm._v("Northwestern")
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.$auth.watch.authenticated
                ? _c(
                    "v-toolbar",
                    { attrs: { app: "", color: "primary" } },
                    [
                      _c("h3", { staticClass: "applogo" }, [
                        _vm._v("Information Technology")
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$auth.watch.authenticated
                ? _c(
                    "v-toolbar",
                    { attrs: { app: "", color: "primary" } },
                    [
                      _c(
                        "h3",
                        {
                          class: [
                            "applogo",
                            _vm.teamName ? "applogo--with-teamname" : ""
                          ]
                        },
                        [_vm._v("\n          Room Ready\n        ")]
                      ),
                      _vm._v(" "),
                      _vm.teamName
                        ? _c("h4", { staticClass: "teamname white--text" }, [
                            _vm._v(_vm._s(_vm.teamName))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _vm.$auth.watch.authenticated
                        ? _c(
                            "v-chip",
                            {
                              attrs: {
                                disabled: "",
                                small: "",
                                color: "white",
                                "text-color": "primary"
                              }
                            },
                            [
                              _vm._v(
                                "\n          " + _vm._s(_vm.$auth.user().uid)
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.teamName,
                                      expression: "teamName"
                                    }
                                  ],
                                  staticStyle: { "margin-left": "0.5em" }
                                },
                                [
                                  _vm._v(
                                    "(" +
                                      _vm._s(
                                        _vm.$auth.user().roles[_vm.team.teamId]
                                      ) +
                                      ")"
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$auth.watch.authenticated
                        ? _c(
                            "v-badge",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false"
                                }
                              ],
                              attrs: {
                                overlap: "",
                                color: "transparent",
                                "content-class": "btn__sync btn--badge"
                              },
                              model: {
                                value: _vm.$syncService.items.length,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.$syncService.items,
                                    "length",
                                    $$v
                                  )
                                },
                                expression: "$syncService.items.length"
                              }
                            },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "badge" }, slot: "badge" },
                                [_vm._v(_vm._s(_vm.$syncService.items.length))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: _vm.$syncService.items.length
                                      ? "error"
                                      : "white",
                                    flat: "",
                                    round: "",
                                    icon: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$syncService.sync()
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("sync")])],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("rr-main-menu")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-content",
                { attrs: { id: "app-content" } },
                [_c("flash-message"), _vm._v(" "), _c("router-view")],
                1
              ),
              _vm._v(" "),
              !_vm.$auth.watch.authenticated
                ? [
                    _c("footer", [
                      _c("div", { staticClass: "contain-970 group" }, [
                        _c("div", { staticClass: "footer-content" }, [
                          _c(
                            "a",
                            { attrs: { href: "http://www.northwestern.edu" } },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    "/static/img/northwestern-university.svg",
                                  alt: "Northwestern University"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("ul", [
                            _c("li", [
                              _vm._v(
                                "© " +
                                  _vm._s(_vm.currentYear) +
                                  " Northwestern University"
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "http://www.northwestern.edu/contact.html"
                                  }
                                },
                                [_vm._v("Contact Northwestern University")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "http://www.northwestern.edu/hr/careers/"
                                  }
                                },
                                [_vm._v("Careers")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "http://www.northwestern.edu/disclaimer.html"
                                  }
                                },
                                [_vm._v("Disclaimer")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "http://www.northwestern.edu/emergency/index.html"
                                  }
                                },
                                [_vm._v("Campus Emergency Information")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "http://policies.northwestern.edu/"
                                  }
                                },
                                [_vm._v("University Policies")]
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "footer-content contact" }, [
                          _c("ul", [
                            _c("li", { staticClass: "footer-pin-icon" }, [
                              _c("span", { staticClass: "hide-label" }, [
                                _vm._v("Address")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("strong", [_vm._v("Information Technology")])
                            ]),
                            _vm._v(" "),
                            _c("li", [_vm._v("1800 Sherman Avenue")]),
                            _vm._v(" "),
                            _c("li", [_vm._v("Evanston, IL 60201")])
                          ]),
                          _vm._v(" "),
                          _c("ul", [
                            _c("li", { staticClass: "footer-phone-icon" }, [
                              _c("span", { staticClass: "hide-label" }, [
                                _vm._v("Phone number")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [_vm._v("(847) 491-4357")])
                          ]),
                          _vm._v(" "),
                          _c("ul", [
                            _c("li", { staticClass: "footer-email-icon" }, [
                              _c("span", { staticClass: "hide-label" }, [
                                _vm._v("Email address")
                              ])
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "mailto:consultant@northwestern.edu"
                                  }
                                },
                                [_vm._v("consultant@northwestern.edu")]
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "footer-content" }, [
                          _c("p", [_c("strong", [_vm._v("Social Media")])]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "social facebook",
                              attrs: { href: "http://www.facebook.com/NU1HELP" }
                            },
                            [_vm._v("Facebook")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "social twitter",
                              attrs: { href: "http://www.twitter.com/nu1help" }
                            },
                            [_vm._v("Twitter")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "social youtube",
                              attrs: {
                                href:
                                  "http://www.youtube.com/user/nuitcommunications"
                              }
                            },
                            [_vm._v("YouTube")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "footer-content" },
                          [
                            _c(
                              "v-btn",
                              {
                                class: ["primary--text", "ma-0"],
                                attrs: {
                                  id: "request_demo",
                                  color: "white",
                                  block: "",
                                  href:
                                    "https://mediadesign.it.northwestern.edu/portfolio/roomready/",
                                  target: "_blank"
                                }
                              },
                              [
                                _c("strong", { staticClass: "btn__text" }, [
                                  _vm._v("Request a Demo")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { attrs: { role: "region", id: "roomready-version" } }, [
            _c("em", [_vm._v("v2.2.51")])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = Ty93
// module chunks = 1